<template>
    <layout-card
        class="card-last_object"
        :error="error"
        :loading="loading"
        :placeholder="placeholder"
        :isCustomizable="settings.isCustomizable"
        @refresh-card="fetchCard('last_object', {}, true)"
        @edit-card="toggleSettingsForm"
        @hide-card="$emit('hide-card', 'last_object')"
    >
        <!-- SLOTED TITLE -->
        <template #title>
            {{ name }}
            <portal to="dashboardSettingsForm">
                <card-setting-overlay
                    v-if="showSettingsForm"
                    :formName="settingsFormName"
                    :cardCustomSettings="customSettings"
                    :cardSettings="settings"
                    :cardName="type"
                    @fetched="fetchCard"
                    @close-form="toggleSettingsForm"
                    @custom-settings-saved="fetchCard(type, {}, true)"
                />
            </portal>
        </template>

        <!-- SLOTED CONTENT -->
        <template #content>
            <div
                v-if="(cardData && cardData.length > 0) || (cardData && cardData.error)"
                class="ov-auto"
            >
                <div v-if="!cardData.error">
                    <ul v-for="object in data" :key="object.id">
                        <!-- URL -->
                        <a :href="object.url" class="url">
                            <!-- ICÔN -->
                            <li class="flex-row p-2">
                                <CompassIcon :icon="getIconByType(object.type)" class="mt-2" />

                                <!-- CONTENT -->
                                <div class="flex-column ml-4 wp-10 ov-reset">
                                    <p class="mb-1 fs-2 between">
                                        <span class="gray-60">
                                            {{ humanNameType(object.type) }}
                                        </span>
                                        <span class="grey time">
                                            {{
                                                $filters.dateFormatter(
                                                    object.timestamp,
                                                    'SLASHED_DATE_TIME',
                                                )
                                            }}
                                        </span>
                                    </p>
                                    <p class="semibold fs-3">{{ object.name }}</p>
                                </div>
                            </li>
                        </a>
                    </ul>
                </div>
                <div v-else>
                    <div class="alert alert-danger">{{ cardData.error }}</div>
                </div>
            </div>
        </template>
    </layout-card>
</template>

<script>
import LayoutCard from './LayoutCard.vue';
import CardMixin from './CardMixin.js';
import IconMixin from './../../../mixins/IconMixin.js';
import HumanNameTypeMixins from './../../../mixins/HumanNameTypeMixins.js';

export default {
    mixins: [CardMixin, IconMixin, HumanNameTypeMixins],
    created() {
        window.EventBus.on('refresh_last_object', () => {
            this.fetchCard(this.type);
        });
    },
    data() {
        return {
            settingsFormName: 'last-object-setting-form',
        };
    },
    computed: {
        placeholder() {
            return this.$l10n.__("Vous n'avez créé aucun élément");
        },
    },
    components: {
        LayoutCard,
    },
};
</script>

<style lang="scss" scoped>
@import '~@sellsy/styleguide/src/_variables';
@import '~@sellsy/styleguide/src/_mixins';

.between {
    display: flex;
    justify-content: space-between;
}

.time {
    min-width: 110px;
    padding-left: 15px;
}

.url {
    display: block;
    @include border-radius();
    cursor: pointer;

    &:hover {
        background-color: $primary-05;
    }
}
</style>
